import { useState, useContext, useEffect } from "react";
import { useNavigate, NavLink } from "react-router-dom";
import { AuthContext } from "./Authentication";
//import { ShapeContext } from "./Shapefile";
import "./styles/Home.css";

const Home = () => {
  //const ref = useRef(null);
  const [alertVisible, setAlertVisibility] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const { user, signIn, getAuthUser } = useContext(AuthContext);
  //const { importShp } = useContext(ShapeContext);
  const navigate = useNavigate();
  //const [ user, setUser ] = useState();

  useEffect(() => {
    if (user) {
      console.log(user);
    } else {
      getAuthUser().then((resp) => {
        if (resp == null) {
          console.log("Não tem usuario logado resp = ", resp);
          navigate("/");
          return;
        }
        console.log(resp);
        //setUser(resp);
        console.log(user);
      });
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    signIn(email, password)
      .then((data) => {
        //console.log(data);
        navigate("/painel");
      })
      .catch((err) => {
        //console.log(err.message);
        setErrorMessage(err.message);
        setAlertVisibility(true);
      });
  };

  return (
    <div id="Home">
      <span className="Home-span">
        <img
          className="Home-logo"
          src={require("../assets/images/Logo Fanttech.png")}
          alt="10"
        />
      </span>
      <form className="Home-form" onSubmit={handleSubmit}>
        <label>E-mail:</label>
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <label>Senha:</label>
        <input
          type="password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <NavLink className="navlink">Esqueceu sua senha?</NavLink>
        <input type="submit" value="Entrar"></input>
        <label>Ainda não é registrado?</label>
        <NavLink to="/signup" className="navlink">
          Registre-se
        </NavLink>
      </form>
      {alertVisible && <div className="alert">{errorMessage}</div>}
    </div>
  );
};

export default Home;
